
export const TextElement = ({ value, parse = true, style = {} }) => {

    return (
        <div style={{ ...style }} >{value ? value.replace(/^"+|"+$/g, '') + "" : ""}</div>
    )
}